import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/";
import "./index.scss";

const Layout = () => {
  return (
    <div className="demo">
      <Sidebar />
      <div className="page body2">
        <span className="tags top-tags bottom-tag-html">
          &lt;html&gt;
          <br />
          <span style={{ marginLeft: "26%" }} className="top-tags">
            &lt;body&gt;
          </span>
        </span>

        <Outlet />
        <span className="tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </div>
  );
};

export default Layout;
